export { FilePicker } from "./file-picker.component";
